import { graphql, useStaticQuery } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"
import styled from "styled-components"
import { Gap, mixins } from "Styles"
import { theme } from "Theme"
import { Utils } from "Components"

const Wrapper = styled.div`
  color: ${({ dark }) => (dark ? theme.colors.white.base : theme.colors.black.base)};
  background: ${({ dark }) => (dark ? theme.colors.background.dark : theme.colors.background.white)};

  ${(props) =>
    props.image && (!props.vimeoId || !props.youtubeId) ? (!props.dark ? "" : mixins.backgroundBefore) : ""}

  min-height: ${(props) => (props.big ? "300px;" : "100px;")};
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  .gatsby-image-wrapper {
    position: initial !important;
  }
`

const Content = styled.div`
  width: 100%;
  padding: 3rem 0;
  position: relative;
  z-index: 3;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const Testimonial = styled.h3`
  color: inherit;
  font-size: ${theme.fontSize.h5};
  font-family: ${theme.fontFamily.qoute};
  font-style: italic;
  font-weight: normal;
  line-height: 2.3rem;
  max-width: ${theme.layout.base};
  text-align: left;
  margin: 0 auto;
  padding: 2rem;
  @media (min-width: ${theme.breakpoints.s}) {
    padding: 2rem;
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
  &:before {
    content: "“";
    position: relative;
    color: ${theme.colors.white.base};
    font-family: Arial;
    opacity: 0.6;
    top: 36px;
    left: 0;
    padding-right: 18px;
    font-size: 82px;
    font-weight: bold;
    display: inline;
    line-height: 0px;
  }

  &:after {
    content: "”";
    position: relative;
    color: ${theme.colors.white.base};
    font-family: Arial;
    opacity: 0.6;
    top: 40px;
    left: 0;
    padding-left: 0px;
    font-size: 82px;
    font-weight: bold;
    display: inline;
    line-height: 0px;
  }
`

const AuthorBlock = styled.div`
  max-width: ${theme.layout.base};
  text-align: center;
  margin: 0 auto;
  display: grid;
  padding: 2rem;
  grid-template-rows: 92px 2fr;
  @media (min-width: ${theme.breakpoints.s}) {
    padding: 2rem;
  }
  @media (min-width: ${theme.breakpoints.m}) {
    grid-template-columns: 92px 2fr;
    text-align: left;
  }
  @media (min-width: ${theme.breakpoints.l}) {
    grid-template-columns: 92px 2fr;
  }
  grid-gap: 16px;
`

const AuthorImage = styled.div`
  height: 92px;
  width: 92px;
  position: relative;
  margin: 0 auto;
  overflow: hidden;
  border-radius: ${theme.borderRadius.round};
  photo {
    img {
      margin: 0;
      border-radius: ${theme.borderRadius.round};
    }
  }
  @media (min-width: ${theme.breakpoints.m}) {
    margin: 0 0 0 auto;
  }
`

const AuthorDetails = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: ${theme.breakpoints.m}) {
  }
  position: relative;
  margin: 0 auto 0 0;
`

const TestimonialText = styled.h4`
  color: ${theme.colors.white.base};
  margin: 0 0 8px 0;
  display: block;
  position: relative;
  font-size: ${theme.fontSize.xlarge};
  font-family: ${theme.fontFamily.qoute};
  font-style: italic;
  font-weight: normal;
  line-height: 1.7rem;
  margin: 0;
  @media (min-width: ${theme.breakpoints.m}) {
    max-width: 800px;
  }
`

const AuthorTitle = styled.h5`
  color: ${theme.colors.white.grey};
  margin: 0 0 8px 0;
`

const AuthorCompany = styled.h5`
  color: ${theme.colors.white.base};
  margin: 0;
`

const Dim = () => (
  <div
    style={{
      backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.4))",
      width: "100%",
      height: "100%",
      backgroundSize: "cover",
      position: "absolute",
      top: 0,
      zIndex: 3,
    }}></div>
)

const ColorDim = (color) => (
  <div
    style={{
      background: color ? `${Utils.BrandColor(color.color.toLowerCase())}` : `${mixins.backgroundBefore}`,
      opacity: color ? `0.5` : `1`,
      width: "100%",
      height: "100%",
      backgroundSize: "cover",
      position: "absolute",
      top: 0,
      zIndex: 1,
    }}></div>
)

const query = graphql`
  {
    avatar: file(name: { eq: "male" }, extension: { regex: "/(jpg)/" }) {
      childImageSharp {
        fluid(maxWidth: 480, quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    person: file(name: { eq: "john-bernard" }, extension: { regex: "/(jpg)/" }) {
      childImageSharp {
        fluid(maxWidth: 480, quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

const SectionTestimonial = ({
  big,
  dark,
  grid,
  color,
  image,
  testimonial,
  name,
  title,
  company,
  youtubeId,
  vimeoId,
}) => {
  const { avatar, person } = useStaticQuery(query)
  console.log({ avatar, person }, name, title, company)
  const avatarImage = person.childImageSharp

  return (
    <>
      {(vimeoId || youtubeId) && <Gap />}
      <Wrapper dark={dark ? 1 : undefined} big={big} image={image} youtubeId={youtubeId} vimeoId={vimeoId}>
        {image && (
          <>
            <GatsbyImage alt={""} title={title} image={image.gatsbyImageData} />
            {color && <ColorDim color={color} />}
            {!color && <Dim />}
          </>
        )}
        <Content grid={grid}>
          <div>
            {testimonial && <Testimonial>{testimonial}</Testimonial>}
            <AuthorBlock>
              <AuthorImage>
                <GatsbyImage
                  alt={`${name} | ${title} at ${company}`}
                  title={`${name} | ${title} at ${company}`}
                  image={avatarImage.gatsbyImageData}
                />
              </AuthorImage>
              <AuthorDetails>
                {name && <TestimonialText>{name}</TestimonialText>}
                <br />
                {title && <AuthorTitle>{title}</AuthorTitle>}
                {company && <AuthorCompany>{company}</AuthorCompany>}
              </AuthorDetails>
            </AuthorBlock>
          </div>
        </Content>
      </Wrapper>
    </>
  )
}

export default SectionTestimonial
